<template>
  <div class="video-player-container">
    <video
      ref="videoPlayer"
      class="video-js vjs-big-play-centered"
    ></video>
  </div>
</template>

<script>
import videojs from "video.js";
//样式文件注意要加上
import "video.js/dist/video-js.css";
export default {
  name: "VideoPlayer",
  props: ['videoUrl'],
  data () {
    return {
      player: null,
      isVisible: false,
      observer: null
    }
  },
  watch: {
    // 不能用 immediate：created 阶段 $refs 还不存在；首次加载由 IntersectionObserver 触发
    videoUrl (newUrl) {
      this.handleUrlChange(newUrl)
    }
  },
  mounted() {
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.isVisible = true;
          this.$nextTick(() => {
            if (this.videoUrl) {
              this.initPlayer(this.videoUrl);
            }
          });
          this.observer.unobserve(this.$refs.videoPlayer);
        }
      });
    });
    this.observer.observe(this.$refs.videoPlayer);
  },
  methods: {
    initPlayer (newUrl) {
      // 未挂载、无地址或已初始化时直接跳过，避免 $refs 不存在报错和重复初始化
      if (!newUrl || !this.$refs.videoPlayer || this.player) return
      const playerOptions = {
        preload: 'auto',
        autoplay: false,
        controls: true,
        interactive: true,
        playbackRates: [1, 1.25, 1.5, 2],
        fluid: true,
        controlBar: {
          volumePanel: {
            inline: false,
            volumeControl: {
              vertical: true
            }
          }
        },
        // 不指定 type，由浏览器根据实际返回内容判断，避免 MIME 写错导致 MEDIA_ERR_SRC_NOT_SUPPORTED
        sources: [
          { src: newUrl }
        ]
      }
      // 初始化播放器
      this.player = videojs(
        this.$refs.videoPlayer,
        playerOptions,
        function onPlayerReady() {
          const onMetadataLoaded = () => {
            // 执行 load 方法
            this.load();
            // 移除事件监听
            this.off('loadedmetadata', onMetadataLoaded);
          };
          this.on('loadedmetadata', onMetadataLoaded);
        }
      )
      // 错误监听在播放器创建后立即注册，保证失效链接能触发 video-error 通知父组件
      this.player.on('error', () => {
        const err = this.player.error()
        console.error('视频播放器出错:', err)
        this.$emit('video-error', err)
      })
    },
    handleUrlChange(newUrl) {
      if (!newUrl) return
      if (!this.player) {
        this.initPlayer(newUrl)
        return
      }
      // 小技巧：先暂停再切换源
      this.player.pause()
      this.player.src({ src: newUrl })
      // 强制重新加载（解决某些浏览器缓存问题）
      this.$nextTick(() => {
        this.player.load()
      })
    },



    // handlePlayerInit(player) {
    //   this.player = player
    //   console.log('播放器实例已获取', player)

    //   // 可以在这里添加事件监听
    //   player.on('play', () => {
    //     console.log('视频开始播放')
    //   })

    //   player.on('pause', () => {
    //     console.log('视频已暂停')
    //   })

    //   player.on('ended', () => {
    //     console.log('视频播放结束')
    //   })
    // },
    disposePlayer () {
      if (this.player) {
        this.player.dispose();
        this.player = null;
      }
    }
  },
  beforeDestroy () {
    this.disposePlayer()
  },
}
</script>

<style lang='scss'>
.video-player-container {
  // width: 70%;
  // height: 300px;
  // margin: 0 auto;
  .video-js {
    width: 100%;
    // height: 100%;
    background: none;
    text-align: center;
  }
  // .vjs-has-started .vjs-control-bar {
  //   // height: 0.6rem !important;
  // }
  // .vjs-button > .vjs-icon-placeholder:before {
  //   // font-size: 3rem!important;
  // }
  // .video-js.vjs-fluid:not(.vjs-audio-only-mode){
  //   height: 300px;
  // }
  // .video-js .vjs-tech {
  //   height: 300px;
  // }
}
</style>



// WEBPACK FOOTER //
// src/components/VideoPlayer/index.vue